import { Box, BoxProps, forwardRef } from '@chakra-ui/react';
import { ReactElement, useState } from 'react';
import { useVideo } from 'react-use';

import { PlayIcon } from '../icons';

export interface IVideoProps extends BoxProps {
  alt?: string;
  className?: string;
  containerProps?: BoxProps;
  poster?: string;
  src: string;
  fallback?: ReactElement;
}

export const VideoHover = forwardRef<IVideoProps, 'video'>(
  (
    { alt, containerProps, poster, src, fallback = null, ...videoAttrs },
    ref,
  ) => {
    const [error, setError] = useState(false);
    const [video, , controls] = useVideo(
      <Box
        as="video"
        role="video"
        data-testid="content-video-player"
        src={src}
        poster={poster}
        ref={ref}
        {...videoAttrs}
        onError={() => setError(true)}
      >
        {alt}
      </Box>,
    );

    controls.mute();

    const handleMouseEnter = () => controls.play();
    const handleMouseLeave = () => controls.pause();

    return error ? (
      fallback
    ) : (
      <Box
        {...containerProps}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <PlayIcon
          color="white"
          boxSize="34px"
          aria-label="Play video"
          position="absolute"
          bottom={0}
          right={0}
          margin={3}
        />
        {video}
      </Box>
    );
  },
);
